import React, {Component} from 'react'
import PropTypes from 'prop-types'
import JobTableHead from "./JobTableHead"
import JobTableBody from "./JobTableBody"
import {Spin} from "antd"

class JobTable extends Component {
    render() {
        const {loading, listJob, getListingJob, limit, page} = this.props

        return (
            <div className="JobTable">
                <Spin spinning={loading} tip={'Đang lấy dữ liệu từ server...'}>
                    <table className='table'>
                        <JobTableHead/>
                        <JobTableBody listJob={listJob} limit={limit} page={page} getListingJob={getListingJob}/>
                    </table>
                </Spin>
            </div>
        )
    }
}

JobTable.propTypes = {
    limit: PropTypes.number,
    page: PropTypes.number,
    getListingJob: PropTypes.func,
    loading: PropTypes.bool.isRequired,
    listJob: PropTypes.array.isRequired
}

export default JobTable